const HEX = "M133.45,0h26.91c7.15,0,13.75,3.81,17.32,10l13.45,23.3c3.57,6.19,3.57,13.81,0,20l-13.45,23.3c-3.57,6.19,-10.18,10,-17.32,10h-26.91c-7.15,0,-13.75,-3.81,-17.32,-10l-13.45,-23.3c-3.57,-6.19,-3.57,-13.81,0,-20l13.45,-23.3C119.71,3.81,126.31,0,133.45,0Z";

export default function HexShape({ size = 200, strokeWidth = 1, className, style }) {
  return (
    <svg
      viewBox="98 -5 97 97"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path d={HEX} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
